'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function stubTrue() {
    return true;
}

exports.stubTrue = stubTrue;
